import MarkdownIt from 'markdown-it';
const $markdown = new MarkdownIt();
export default ({ app }, inject) => {
  inject('markdown', $markdown);
};
